/* eslint-disable global-require */
import React, { Component, Fragment } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './MailingList.module.scss'
import { postRequest } from '@helpers/LambdaHelper'

class MailingList extends Component {
  state = {
    submitted: false,
    focus: false,
    input: '',
    error: false,
    recaptchaToken: null
  }

  initCheckbox = () => {
    this.setState({
      focus: true
    })
  }

  validateEmail (email) {
    let re = /\S+@\S+\.\S+/
    return re.test(String(email).toLowerCase())
  }

  formSubmitted = (e) => {
    e.preventDefault()
    const { input, recaptchaToken } = this.state

    if (this.validateEmail(input)) {
      const reqBody = {
        type: 'SignUp',
        token: recaptchaToken,
        data: {
          email: input
        }
      }
      postRequest(reqBody).then(() =>
        this.setState({
          submitted: true,
          error: false
        }),
      (typeof f24 !== 'undefined') ? f24('event', 'fc_form_send', '#f24-mailing-list') : console.log('f24 not defined')
      )
    } else {
      this.setState({ error: true })
    }
  }

  changeInput = (e) => this.setState({ input: e.target.value })

  recaptchaOnChange = (value) => {
    this.setState({
      recaptchaToken: value
    })
  }

  recaptchaOnExpire = () => {
    this.setState({ recaptchaToken: null })
  }

  render () {
    const { submitted, focus, error, input, recaptchaToken } = this.state
    const { title, message } = this.props

    return (
      <Fragment>
        {submitted ? (
          <div styleName='completed'>{message}</div>
        ) : (
          <form id='f24-mailing-list' styleName='form'>
            <h2 styleName='title'>{title}</h2>
            <span styleName='email'>
              <label for='EmailAddress' styleName='label'><span styleName='lbl-email-address'>Email Address</span>
                <input
                  type='email'
                  id='EmailAddress'
                  name='EmailAddress'
                  placeholder='Email address'
                  onFocus={this.initCheckbox}
                  value={input}
                  onChange={this.changeInput}
                  styleName='input'
                  autoComplete='off'
                /></label>
              {recaptchaToken != null ? (
                <button type='submit' styleName='button' onClick={this.formSubmitted}>
                  Sign Up
                </button>
              ) : (
                <button type='submit' styleName='button' disabled>
                  Sign Up
                </button>
              )}
            </span>
            <span styleName={classnames('contact-check', { show: focus })}>
              <label for='optInEmail' styleName='label'>
                <input type='checkbox' id='optInEmail' name='optInEmail' styleName='check' />
                <span styleName='info'>
                  Please also tick here if you would like other companies within the Travis Perkins Group to contact you
                  with new products and services that may be of interest to you
                </span>
              </label>
            </span>
            <ReCAPTCHA
              sitekey={process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY}
              onChange={this.recaptchaOnChange}
              onExpired={this.recaptchaOnExpire}
            />
            <label class='sr-only' for='g-recaptcha-response'>Google Recaptcha</label>
          </form>
        )}
        {error && <p styleName='error'>Add a valid email!</p>}
      </Fragment>
    )
  }
}

MailingList.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
}

export default MailingList



// WEBPACK FOOTER //
// ./src/components/MailingList/MailingList.js